import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "global-container" }
const _hoisted_3 = { class: "header-container" }
const _hoisted_4 = { class: "text-h4 font-weight-medium" }

import '@vueup/vue-quill/dist/vue-quill.snow.css'
import '@/styles/global.scss'

import HeaderComponent from '@/components/home/HeaderComponent.vue'
import { useTheme } from 'vuetify/lib/composables/theme'
import { firestore as db, storage } from '@/main'
import { onMounted, ref } from 'vue'
import { Delta, QuillEditor } from '@vueup/vue-quill'
import { MemberCreateRequest } from '@/types/Member'
import { MemberCategoryType } from '@/enums/MemberCategoryType'
import { MemberDegreeType } from '@/enums/MemberDegreeType'
import { addDoc, collection, doc, DocumentReference, updateDoc } from 'firebase/firestore'
import { getDownloadURL, ref as storageRef, uploadBytes } from 'firebase/storage'
import { useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateMemberView',
  setup(__props) {

const panel = ref([0])
const theme = useTheme()
const selectedImage = ref<File|null>(null)
const showProgress = ref(false)
const career = ref<Delta|undefined>(undefined)
const isEditMode = ref(false)
const router = useRouter()

const memberData = ref<MemberCreateRequest>({
  email: '',
  tel: '',
  website: '',
  career: '',
  cat: MemberCategoryType.PROFESSOR,
  degree: MemberDegreeType.PHD,
  dept: '',
  name: '',
  interests: ''
})

const degrees = [
  { text: 'Ph.D', value: MemberDegreeType.PHD },
  { text: 'M.S', value: MemberDegreeType.MS },
  { text: 'B.S', value: MemberDegreeType.BS },
  { text: 'Undergraduate', value: MemberDegreeType.UNDER_GRADUATE }
]

const categories = [
  { text: 'Professor', value: MemberCategoryType.PROFESSOR },
  { text: 'Researcher', value: MemberCategoryType.RESEARCHER },
  { text: 'Student', value: MemberCategoryType.STUDENT },
  { text: 'Alumni', value: MemberCategoryType.ALUMNI }
]

async function upload () {
  if (memberData.value.name === '' || memberData.value.dept === '' || memberData.value.degree === undefined || memberData.value.cat === undefined) {
    alert('Please fill in all required fields.')
  } else {
    showProgress.value = true

    memberData.value.career = career.value === undefined ? '' : JSON.stringify(career.value)
    let docId = ''

    if (isEditMode.value) {
      docId = history.state.member.id

      await updateDoc(
        doc(db, 'Members', (docId)), {
          ...(memberData.value)
        }
      )
        .catch((e: Error) => {
          alert(`An error occurred while modifying member.\nPlease try again later.\n(${e.message})`)
          showProgress.value = false
        })
    } else {
      const docRef = await addDoc(
        collection(db, 'Members'), {
          ...(memberData.value)
        }
      )
        .catch((e: Error) => {
          alert(`An error occurred while creating a new member.\nPlease try again later.\n(${e.message})`)
          showProgress.value = false
        })

      docId = docRef.id
    }

    if (selectedImage.value !== null) {
      const uploadRef = storageRef(storage, `members/img/${docId}.${selectedImage.value.name.split('.').pop()}`)

      uploadBytes(uploadRef, selectedImage.value)
        .catch((e: Error) => {
          alert(`An error occurred while uploading profile image.\nPlease try again later.\n(${e.message})`)
          showProgress.value = false
        })
        .then(() => {
          getDownloadURL(uploadRef)
            .then((url) => {
              updateDoc(doc(db, 'Members', docId), { profile: url })
                .catch((e: Error) => {
                  alert(`An error occurred while saving profile image URL.\nPlease try again later.\n(${e.message})`)
                })
                .then(() => {
                  alert(isEditMode.value ? 'Member modified successfully.' : 'New member created successfully.')
                  router.back()
                })
                .finally(() => {
                  showProgress.value = false
                })
            })
            .catch((e: Error) => {
              alert(`An error occurred while retrieving profile image URL.\nPlease try again later.\n(${e.message})`)
              showProgress.value = false
            })
        })
    } else {
      alert(isEditMode.value ? 'Member modified successfully.' : 'New member created successfully.')
      showProgress.value = false
      router.back()
    }
  }
}

onMounted(() => {
  if (history.state.member) {
    isEditMode.value = true
    memberData.value = { ...(history.state.member as MemberCreateRequest) }
    career.value = memberData.value.career ? new Delta(JSON.parse(history.state.member.careerDelta)) : undefined
  }
})


return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createVNode(HeaderComponent, {
              title: isEditMode.value ? 'Modify Member' : 'Create New Member',
              "show-leading-btn": true,
              "leading-icon": 'fa-solid fa-chevron-left',
              "trailing-icon": isEditMode.value ? 'fa-solid fa-check' : 'fa-solid fa-plus',
              "show-progress": showProgress.value,
              onOnClick: upload,
              onOnLeadingBtnClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
            }, null, 8, ["title", "trailing-icon", "show-progress"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_img, {
              class: "mb-4",
              src: memberData.value.cat === _unref(MemberCategoryType).ALUMNI ? require(
              `@/assets/img_placeholder_graduate_${_unref(theme).current.value.dark ? 'dark' : 'light'}.png`
            ) : require(`@/assets/img_placeholder_employee_${_unref(theme).current.value.dark ? 'dark' : 'light'}.png`)
              ,
              "max-width": "200",
              "max-height": "200"
            }, null, 8, ["src"]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(memberData.value.name), 1),
              _createElementVNode("div", null, _toDisplayString(memberData.value.dept), 1)
            ])
          ]),
          _createVNode(_component_v_expansion_panels, {
            modelValue: panel.value,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((panel).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_expansion_panel, {
                title: "Required Informations",
                class: "rounded-xl",
                expand: "",
                "expand-icon": 
              memberData.value.name !== '' && memberData.value.dept !== '' && memberData.value.degree !== undefined && memberData.value.cat !== undefined
                ? 'mdi-check'
                : 'mdi-chevron-down'
            
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_expansion_panel_text, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_v_text_field, {
                          variant: "solo-filled",
                          color: "primary",
                          modelValue: memberData.value.name,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((memberData.value.name) = $event)),
                          label: "Name",
                          "prepend-inner-icon": "mdi-account",
                          "clear-icon": "mdi-close",
                          clearable: "",
                          "onClick:clear": _cache[2] || (_cache[2] = ($event: any) => (memberData.value.name = ''))
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_v_text_field, {
                          variant: "solo-filled",
                          color: "primary",
                          modelValue: memberData.value.dept,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((memberData.value.dept) = $event)),
                          label: "Department",
                          "prepend-inner-icon": "mdi-office-building",
                          "clear-icon": "mdi-close",
                          clearable: "",
                          "onClick:clear": _cache[4] || (_cache[4] = ($event: any) => (memberData.value.dept = ''))
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_v_select, {
                          variant: "solo-filled",
                          modelValue: memberData.value.degree,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((memberData.value.degree) = $event)),
                          items: degrees,
                          label: "Degree",
                          "prepend-inner-icon": "mdi-school",
                          "item-title": "text",
                          "item-value": "value",
                          color: "primary"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_v_select, {
                          variant: "solo-filled",
                          modelValue: memberData.value.cat,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((memberData.value.cat) = $event)),
                          items: categories,
                          label: "Member Type",
                          "prepend-inner-icon": "mdi-badge-account",
                          "item-title": "text",
                          "item-value": "value",
                          color: "primary"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["expand-icon"]),
              _createVNode(_component_v_expansion_panel, {
                title: "Optional Informations",
                class: "rounded-xl",
                expand: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_expansion_panel_text, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_v_text_field, {
                          variant: "solo-filled",
                          modelValue: memberData.value.email,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((memberData.value.email) = $event)),
                          label: "E-Mail",
                          type: "email",
                          color: "primary",
                          "prepend-inner-icon": "mdi-email",
                          "clear-icon": "mdi-close",
                          clearable: "",
                          "onClick:clear": _cache[8] || (_cache[8] = ($event: any) => (memberData.value.email = ''))
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_v_text_field, {
                          variant: "solo-filled",
                          modelValue: memberData.value.tel,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((memberData.value.tel) = $event)),
                          label: "Tel",
                          type: "phone",
                          color: "primary",
                          "prepend-inner-icon": "mdi-phone",
                          "clear-icon": "mdi-close",
                          clearable: "",
                          "onClick:clear": _cache[10] || (_cache[10] = ($event: any) => (memberData.value.tel = ''))
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_v_text_field, {
                          variant: "solo-filled",
                          modelValue: memberData.value.website,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((memberData.value.website) = $event)),
                          label: "Website",
                          type: "url",
                          color: "primary",
                          "prepend-inner-icon": "mdi-web",
                          "clear-icon": "mdi-close",
                          clearable: "",
                          "onClick:clear": _cache[12] || (_cache[12] = ($event: any) => (memberData.value.website = ''))
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_v_text_field, {
                          variant: "solo-filled",
                          modelValue: memberData.value.interests,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((memberData.value.interests) = $event)),
                          label: "Interests",
                          color: "primary",
                          "prepend-inner-icon": "mdi-star",
                          "clear-icon": "mdi-close",
                          clearable: "",
                          "onClick:clear": _cache[14] || (_cache[14] = ($event: any) => (memberData.value.interests = ''))
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_v_file_input, {
                          modelValue: selectedImage.value,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((selectedImage).value = $event)),
                          "prepend-icon": "mdi-camera",
                          label: isEditMode.value ? 'Change Profile Image' : 'Profile Image',
                          accept: "image/*",
                          variant: "solo-filled"
                        }, null, 8, ["modelValue", "label"]),
                        _createVNode(_unref(QuillEditor), {
                          placeholder: "Career",
                          content: career.value,
                          "onUpdate:content": _cache[16] || (_cache[16] = ($event: any) => ((career).value = $event)),
                          theme: "snow",
                          toolbar: "full"
                        }, null, 8, ["content"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})